export default function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            After the initial setup, you only pay for minutes used by AI on actual conversations
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-8 py-12 text-center">
              <h3 className="text-3xl font-bold text-white mb-2">Custom Enterprise Solution</h3>
              <p className="text-orange-50 text-lg">Tailored to your business requirements</p>
            </div>

            <div className="p-12">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-6">What's Included:</h4>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Custom AI voice agent training</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Unlimited inbound & outbound calls</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">CRM & calendar integrations</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">24/7 customer support</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-6">Perfect For:</h4>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <i className="ri-building-line text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Local businesses</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-briefcase-line text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Professional services</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-team-line text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">HR & recruiting teams</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-store-line text-orange-500 text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">E-commerce businesses</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="text-center pt-8 border-t border-gray-200">
                <p className="text-gray-600 mb-6 text-lg">
                  Let's discuss your specific needs and create a solution that works for you
                </p>
                <a
                  href="https://calendly.com/instavisible/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-8 py-4 bg-orange-500 text-white text-lg font-semibold rounded-full hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-line mr-2 text-xl"></i>
                  Schedule a Consultation
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-gray-500">
              All plans include a 30-day money-back guarantee. No long-term contracts required.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
